import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";

import { useStyles } from "../../../layout/Styles";
import FormPaper from "../../../layout/FormPaper";
import FieldWrapper from "../../../layout/FieldWrapper";
import * as CONST from "../../../Constants";
import Container from "../../../layout/Container";
import * as API from "../../../api";

const propTypes = {
  cpr: PropTypes.object.isRequired,
  handleUpdated: PropTypes.func.isRequired,
  handleFlash: PropTypes.func.isRequired,
  dispatch: PropTypes.func.isRequired,
};
NotConfirmedPrompt.prototype = propTypes;
export default function NotConfirmedPrompt(props) {
  const styles = useStyles();
  const [value, setValue] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = () => {
    let req = { option_value: 8, cpr_id: props.cpr.id, notification_id: props.cpr.current_notification_id };
    if (value) { req['comment'] = value; }

    API.postCprStatus(req)
      .then((res) => {
        if (res.data.cpr) {
          props.dispatch(res.data.cpr);
          props.handleUpdated();
          props.handleFlash({
            success: CONST.FLASH.REJECTED,
          });
        } else {
          props.handleUpdated();
          props.handleFlash({
            error: CONST.FLASH.ERROR,
          });
        }
        setSubmitting(false);
      })
      .catch((err) => console.log(err));
  };

  return (
    <FormPaper>
      <Box m={2}>
        <FieldWrapper
          title={CONST.SELECTED_NO_PROMPT_TEXT}
          children={
            <Container>
              <textarea placeholder="" onChange={(e) => setValue(e.target.value)} />
              <Box mt={2}>
                <button
                  disabled={submitting}
                  id="no-confirm-submit-button"
                  className="prompt confirm"
                  onClick={(e) => {
                    e.preventDefault();
                    setSubmitting(true);
                    handleSubmit();
                  }}
                >
                  {"Submit "}
                </button>
              </Box>
            </Container>
          }
        />
      </Box>
    </FormPaper>
  );
}
